import { formatCurrency, toUnitCharacter } from "@sa-nu/shared-utils/price";

import type { AccommodationClass } from "../../../../__generated__/gql/graphql";

import { DescriptionHeader } from "./description-header";

export type DescriptionForAccommodationClassMessages = {
  heading: (accommodationClass: string) => string;
  feePerNight: (formattedFee: string) => string;
  appliesFromNote: (formattedDate: string) => string;
  unitCharacter: string;
};

const JA_MESSAGES: DescriptionForAccommodationClassMessages = {
  heading: (accommodationClass) =>
    `こちらの施設は ${accommodationClass} クラスです`,
  feePerNight: (formattedFee) =>
    `1泊あたり ${formattedFee}（税込）の追加料金がかかります。`,
  appliesFromNote: (formattedDate) =>
    `※${formattedDate}以降の宿泊から適用されます`,
  unitCharacter: "円",
};

/**
 * クラス追加料金の説明。追加料金がかかる場合だけ表示する
 *
 * @param ruleRevision2027AppliesFrom 2027年度改定のルールが適用される最初の宿泊日（整形済み）。指定すると適用開始日の注記を出す
 */
export function DescriptionForAccommodationClass({
  accommodationClass,
  additionalFeePerNight,
  ruleRevision2027AppliesFrom = null,
  messages = JA_MESSAGES,
}: {
  accommodationClass: AccommodationClass;
  additionalFeePerNight: number;
  ruleRevision2027AppliesFrom?: string | null;
  messages?: DescriptionForAccommodationClassMessages;
}) {
  return (
    <div className="mt-[20px] w-full space-y-[20px]">
      <DescriptionHeader
        iconSrc={`/i/icon_accommodation_class_${accommodationClass.toLowerCase()}.svg`}
        iconAlt="Class"
      >
        {messages.heading(accommodationClass)}
      </DescriptionHeader>
      <div className="text-xs md:text-sm">
        {messages.feePerNight(
          formatCurrency(additionalFeePerNight, {
            unitCharacter: toUnitCharacter(messages.unitCharacter),
          }),
        )}
        {ruleRevision2027AppliesFrom !== null && (
          <>
            <br />
            <span className="text-skogecha-60">
              {messages.appliesFromNote(ruleRevision2027AppliesFrom)}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
